export const environment = {
  production: true,
  enforceHttps: true,
  apiRoute: 'https://boma-api-administration-staging.azurewebsites.net/',
  apiVersion: '1.0',
  firebaseConfig: {
    apiKey: 'AIzaSyDd4Seep-sZI7lZAZqzLTjoJm5zslv76go',
    authDomain: 'boma-4695e.firebaseapp.com',
    projectId: 'boma-4695e',
    storageBucket: 'boma-4695e.appspot.com',
    messagingSenderId: '274558524244',
    appId: '1:274558524244:web:544ba8322fce09baa986c1',
    measurementId: 'G-M7KXX6XY6K',
  },
  authentication: {
    issuer: 'https://auth-staging.boma.today/',
    clientId: 'staging-adminstration-portal',
    scopes: 'openid offline_access api',
  },
};
